import { GetIco } from '@/utils/icons'
import cn from 'classnames'
import { FC, useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom'
import classes from './index.module.css'
import Moment from 'react-moment'
import { LicenseAndPaymentData } from '@/api/types/licenseAndPayment.types'
import { licenseAndPaymentApi } from '@/api/queries/licenseAndPayment'
import { isError } from '@/helpers/checkQuery'
import { Tooltip } from 'antd'
import { getLicensePaymentStatus } from '@/utils/licensePaymentStatus'

interface LicenseAndPaymentButtonProps {
  className?: string
  isMinimizedMenu: boolean
}

const LicenseAndPaymentButton: FC<LicenseAndPaymentButtonProps> = ({
  className,
  isMinimizedMenu,
}) => {
  const [data, setData] = useState<LicenseAndPaymentData>()

  const handlerLoadData = () => {
    licenseAndPaymentApi
      .getData()
      .then((res) => {
        if (isError(res)) throw new Error()

        setData(res.data.data)
      })
      .catch((error: any) =>
        console.error('Ошибка загрузки данных о лицензиях и оплатах: ', error),
      )
  }

  useEffect(() => handlerLoadData(), [])

  const paymentStatus = getLicensePaymentStatus(data?.expiration_date)
  const shouldTrackExpiration = Boolean(
    data && (data.is_trial || data.has_payments || !data.is_free),
  )
  const isPaymentOverdue = Boolean(
    shouldTrackExpiration && paymentStatus === 'expired',
  )
  const isPaymentExpiringSoon = Boolean(
    shouldTrackExpiration && paymentStatus === 'expiresSoon',
  )
  const sidebarDate = data?.is_trial
    ? data.expiration_date
    : data?.closing_date
  const linkTitle = isPaymentOverdue
    ? data?.is_trial
      ? 'Пробный период завершён — Лицензии и оплаты'
      : 'Оплата просрочена — Лицензии и оплаты'
    : isPaymentExpiringSoon
    ? data?.is_trial
      ? 'Пробный период скоро завершится — Лицензии и оплаты'
      : 'Оплата скоро истечёт — Лицензии и оплаты'
    : 'Лицензии и оплаты'

  return (
    <Tooltip title={isMinimizedMenu ? linkTitle : ''} placement="right">
        <NavLink
          to="/license-and-payment"
          className={cn(
            classes.navLink,
            {
              [classes.center]: isMinimizedMenu,
              [classes.expired]: isPaymentOverdue,
              [classes.expiringSoon]: isPaymentExpiringSoon,
            },
            className,
          )}
          title={linkTitle}
          aria-label={linkTitle}
        >
          <GetIco icon="credit_card_2" className={classes.icon} />
          {!isMinimizedMenu && (
            <div className={classes.content}>
              {(isPaymentOverdue || isPaymentExpiringSoon) && (
                <span
                  className={cn(classes.paymentBadge, {
                    [classes.expiredBadge]: isPaymentOverdue,
                    [classes.expiringSoonBadge]: isPaymentExpiringSoon,
                  })}
                >
                  {isPaymentOverdue
                    ? data?.is_trial
                      ? 'Пробный период завершён'
                      : 'Оплата просрочена'
                    : data?.is_trial
                    ? 'Пробный период скоро завершится'
                    : 'Оплата скоро истечёт'}
                </span>
              )}
              <p
                className={cn(classes.title, {
                  [classes.colorDanger]: isPaymentOverdue,
                  [classes.colorWarning]: isPaymentExpiringSoon,
                })}
              >
                Лицензии и оплаты
              </p>
              {sidebarDate && paymentStatus !== 'expired' && (
                <p
                  className={cn(
                    paymentStatus !== 'expiresSoon'
                      ? classes.subTitle
                      : classes.subTitleWarning,
                  )}
                >
                  {data?.is_trial ? 'Пробный период до ' : 'Доступ закроется '}
                  <Moment
                    date={sidebarDate}
                    format="DD.MM.YYYY"
                    withTitle
                  />
                </p>
              )}
            </div>
          )}
        </NavLink>
    </Tooltip>
  )
}

export default LicenseAndPaymentButton
